/* babbooll — merkelementen buiten de landingssecties (cart-drawer, cart-pagina) */
(function () {
  'use strict';

  var REVIEWS = [
    { q: 'Van 2,5 uur slaap naar 7.',        n: 'Charlotte' },
    { q: 'Eindelijk kan ik haar neerleggen.', n: 'Lotte' },
    { q: 'Om 3 uur \'s nachts goud waard.',   n: 'Thomas' }
  ];

  var STER = '<svg viewBox="0 0 20 20" width="11" height="11" aria-hidden="true">' +
             '<path fill="currentColor" d="M10 1.6l2.5 5.3 5.7.8-4.1 4 1 5.7-5.1-2.8-5.1 2.8 1-5.7-4.1-4 5.7-.8z"/></svg>';

  function maakBlok() {
    var el = document.createElement('div');
    el.className = 'blp-cart-review';

    var kaarten = REVIEWS.map(function (r) {
      return '<figure class="blp-cr-kaart">' +
               '<span class="blp-cr-stars">' + STER.repeat(5) + '</span>' +
               '<blockquote class="blp-cr-quote">' + r.q + '</blockquote>' +
               '<figcaption class="blp-cr-naam">' + r.n + '</figcaption>' +
             '</figure>';
    }).join('');

    el.innerHTML = '<div class="blp-cr-strip">' + kaarten + '</div>';
    return el;
  }

  function plaats() {
    // Vlak vóór de afrekenknop — laatste geruststelling, en niets wordt bedekt.
    // De samenvatting is sticky, dus bovenaan plaatsen zou de productlijst overlappen.
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var houder = ctas.parentElement;
      if (!houder || houder.querySelector('.blp-cart-review')) return;
      houder.insertBefore(maakBlok(), ctas);
    });

    // terugval: cart-pagina zonder .cart__ctas
    if (!document.querySelector('.blp-cart-review')) {
      var knop = document.querySelector('.cart__checkout-button, [name="checkout"]');
      if (knop && knop.parentElement && knop.parentElement.parentElement) {
        knop.parentElement.parentElement.insertBefore(maakBlok(), knop.parentElement);
      }
    }
  }

  function start() {
    plaats();
    var obs = new MutationObserver(function () { plaats(); });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ---- upsell: beide artikelen tegelijk toevoegen -------------------------
   De knop draagt zijn regels als JSON in data-bab-add. Na toevoegen openen we
   de cart-drawer als het thema er een heeft, anders sturen we naar /cart.
   Gedelegeerd op document, zodat het ook werkt als de sectie later herlaadt. */
/* De cart-drawer van Horizon ververst zichzelf niet na een eigen fetch naar
   /cart/add.js. We vragen de twee secties mee in het antwoord en zetten ze zelf
   terug — dezelfde route die bab-lp.js op de landingspagina's gebruikt. Zonder
   dit belandt de klant op /cart en verliest hij de productpagina. */
function babVervangWagen(sections) {
  var drawerHtml = sections["cart-drawer-section"];
  if (drawerHtml) {
    try {
      var doc = new DOMParser().parseFromString(drawerHtml, "text/html");
      var nieuw = doc.querySelector(".cart-drawer__inner");
      var huidig = document.querySelector(".cart-drawer__inner");
      if (nieuw && huidig) {
        huidig.innerHTML = nieuw.innerHTML;
        huidig.className = nieuw.className; /* haalt o.a. cart-drawer--empty weg */
      }
    } catch (err) { /* stil */ }
  }
  var bubbleHtml = sections["cart-icon-bubble"];
  if (bubbleHtml) {
    try {
      var bdoc = new DOMParser().parseFromString(bubbleHtml, "text/html");
      var nb = bdoc.querySelector(".cart-bubble") || bdoc.body.firstElementChild;
      var cb = document.querySelector(".cart-bubble");
      if (nb && cb) cb.replaceWith(nb);
    } catch (err) { /* stil */ }
  }
}

function toonWagen(sections) {
  babVervangWagen(sections);
  var comp = document.querySelector("cart-drawer-component");
  var host = comp && comp.closest ? comp.closest("theme-drawer") : null;
  if (host && typeof host.open === "function") {
    if (!host.hasAttribute("open")) {
      try { host.open(); return; } catch (err) { /* door naar fallback */ }
    } else {
      return; /* stond al open, inhoud is ververst */
    }
  }
  var opener = document.querySelector(
    '.header-actions__action[aria-label="Cart"], .header-actions__cart-icon, a[href$="/cart"]'
  );
  if (opener && opener.click) opener.click();
  else window.location.href = "/cart";
}

document.addEventListener("click", async function (e) {
  var knop = e.target.closest("[data-bab-add]");
  if (!knop) return;
  /* De chevron zit binnen de duo-knop. Klikken daarop moet de bundel opendoen,
     niet meteen in de wagen leggen. */
  if (e.target.closest("[data-bab-detail]")) return;
  /* De keuzekaarten in het koopblok leggen niets meteen in de wagen: ze KIEZEN.
     Klikken opent de tabel met de fotootjes; de knop "Add to cart" eronder legt
     daarna de gekozen combinatie erin. Dat gebeurt in de submit-handler onderaan
     dit bestand. Knoppen elders (de drie upsells, de bundels) voegen wel direct toe. */
  if (knop.closest(".bab-bb--duo")) return;
  e.preventDefault();
  /* De duo-kaart heeft opgemaakte inhoud (radio, naam, prijs, lint). Die mag je
     niet overschrijven met een statustekst, want dan is de kaart daarna leeg.
     Vandaar een aparte statusregel bij knoppen met kindelementen. */
  var rijk = knop.children.length > 0;
  var status = null, origineel = null;
  if (rijk) {
    status = knop.querySelector(".bab-bb-status");
    if (!status) {
      status = document.createElement("span");
      status.className = "bab-bb-status";
      knop.appendChild(status);
    }
    status.textContent = "Adding…";
    knop.classList.add("is-bezig");
  } else {
    origineel = knop.textContent;
    knop.textContent = "Adding…";
  }
  function zetStatus(t) {
    if (rijk) status.textContent = t;
    else knop.textContent = t;
  }
  knop.disabled = true;
  try {
    var items = JSON.parse(knop.getAttribute("data-bab-add"));
    /* De variant-id in het data-attribuut is die van de serverzijde, dus de eerste
       beschikbare. Kiest de klant een andere kleur of maat, dan staat de juiste id in
       het formulier van het thema. Die wint — maar ALLEEN voor de duo-kaart, want daar
       gaat het over DIT product. Op de upsell-knoppen gaat het over een ander product;
       daar zou dit de klant het verkeerde artikel verkopen. */
    if (knop.closest(".bab-bb--duo")) {
      var gekozen = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (gekozen && gekozen.value && items[0]) items[0].id = Number(gekozen.value);
    }
    var r = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: items,
        sections: "cart-drawer-section,cart-icon-bubble",
      }),
    });
    if (!r.ok) throw new Error(await r.text());
    var data = await r.json();
    zetStatus("Added");
    toonWagen(data.sections || {});
  } catch (err) {
    console.error("bab-upsell:", err);
    zetStatus("Could not add — try again");
  } finally {
    setTimeout(function () {
      knop.disabled = false;
      if (rijk) {
        knop.classList.remove("is-bezig");
        if (status) status.remove();
      } else {
        knop.textContent = origineel;
      }
    }, 2500);
  }
});

/* ---- koopblok: duo-optie -------------------------------------------------
   "Just this one" is de standaard en doet niets. "Buy it with" draagt zelf een
   data-bab-add, dus de handler hierboven legt beide artikelen in de wagen. Deze
   listener zet alleen de visuele staat, zodat zichtbaar is wat er gekozen is. */
document.addEventListener("click", function (e) {
  var optie = e.target.closest("[data-bab-kies]");
  if (!optie) return;
  var groep = optie.closest(".bab-bb-keuze");
  if (!groep) return;
  groep.querySelectorAll("[data-bab-kies]").forEach(function (o) {
    o.classList.toggle("is-active", o === optie);
  });
});

/* ---- secties in beeld laten komen ---------------------------------------
   Eén observer voor de hele pagina. Elementen krijgen .is-in zodra ze binnen
   komen; de CSS doet de rest. Bewust géén observer per element — dat wordt
   traag op een collectiepagina met vijftig kaarten. */
(function () {
  if (!("IntersectionObserver" in window)) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  /* De collectiekop staat altijd bovenaan de pagina, dus die mag nooit op
     opacity:0 beginnen — dan staart de bezoeker naar een lege kop tot de
     observer vuurt. Alleen wat normaal onder de vouw staat, komt omhoog. */
  var doelen = [
    ".bab-cat-in", ".bab-bd-in", ".bab-gr-in", ".bab-bn-in",
    ".bab-ps-in", ".bab-up-pair",
  ];
  /* .bab-bb-usps stond hier ook in, maar die vinkjes staan in de koopkolom en dus
     altijd boven de vouw. Ze op opacity:0 zetten betekende dat het belangrijkste
     argument van de pagina er de eerste tel niet stond. */
  var stagger = [".bab-cat-grid", ".bab-bd-grid", ".bab-gr-grid", ".bab-bn-grid"];

  function markeer() {
    doelen.forEach(function (s) {
      document.querySelectorAll(s).forEach(function (e) {
        if (!e.dataset.babR) { e.dataset.babR = "1"; e.classList.add("bab-reveal"); obs.observe(e); }
      });
    });
    stagger.forEach(function (s) {
      document.querySelectorAll(s).forEach(function (e) {
        if (!e.dataset.babR) { e.dataset.babR = "1"; e.classList.add("bab-reveal-stagger"); obs.observe(e); }
      });
    });
  }

  var obs = new IntersectionObserver(function (rijen) {
    rijen.forEach(function (r) {
      if (!r.isIntersecting) return;
      r.target.classList.add("is-in");
      obs.unobserve(r.target);
    });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });

  /* VEILIGHEIDSNET. De reveal zet opacity op 0 en rekent erop dat de observer
     hem weer aanzet. Vuurt die om welke reden ook niet — een browser zonder
     ondersteuning, een tab die op de achtergrond laadt, een fout hierboven —
     dan blijft de halve pagina onzichtbaar. Na 2,5 seconde tonen we alles
     onvoorwaardelijk. Beter een animatie missen dan een lege pagina. */
  /* De duo-kaart pulseert één keer, kort nadat de pagina staat. Hing eerst aan de
     reveal van de vinkjes; die is weg, en een observer is hier ook niet nodig —
     het koopblok staat altijd in beeld. */
  setTimeout(function () {
    var pop = document.querySelector(".bab-bb-optie--pop");
    if (pop) pop.classList.add("is-hint");
  }, 1200);

  function tonAlles() {
    document.querySelectorAll(".bab-reveal, .bab-reveal-stagger").forEach(function (e) {
      e.classList.add("is-in");
    });
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", markeer);
  else markeer();

  setTimeout(tonAlles, 2500);
  window.addEventListener("pageshow", function () { setTimeout(tonAlles, 2500); });
})();

/* De collectiebeschrijving staat op telefoon ingekort tot drie regels, met een
   knop eronder. Zonder dit stond de eerste productkaart 1500 px onder de vouw.
   Op desktop is de knop verborgen en staat de tekst gewoon voluit. */
document.addEventListener("click", function (e) {
  var knop = e.target.closest("[data-bab-meer]");
  if (!knop) return;
  var tekst = knop.previousElementSibling;
  if (!tekst) return;
  var open = tekst.hasAttribute("data-bab-inkort");
  if (open) tekst.removeAttribute("data-bab-inkort");
  else tekst.setAttribute("data-bab-inkort", "");
  knop.textContent = open ? "Show less" : "Read more";
});

/* De duo-kaart klapt open en laat zien wat er in de bundel zit: beide producten met
   hun eigen prijs, de korting en het totaal. Zonder dat is "Buy it with" een belofte
   zonder onderbouwing — precies wat je op een koopblok niet wil. */
document.addEventListener("click", function (e) {
  var chev = e.target.closest("[data-bab-detail]");
  if (!chev) return;
  e.preventDefault();
  e.stopPropagation();
  var knop = chev.closest("[aria-expanded]");
  var wrap = chev.closest(".bab-bb-duo");
  var paneel = wrap && wrap.querySelector("[data-bab-detail-panel]");
  if (!paneel || !knop) return;

  /* Staat deze keuze nog niet aan, dan kiest de chevron hem ook. Anders kon het
     paneel van optie B openstaan terwijl A gekozen was, en dan koopt de klant iets
     anders dan hij op zijn scherm ziet. Staat hij al aan, dan klapt hij dicht. */
  if (!knop.classList.contains("is-active") && window.babKiesOptie) {
    window.babKiesOptie(knop);
    return;
  }
  var open = knop.getAttribute("aria-expanded") === "true";
  knop.setAttribute("aria-expanded", open ? "false" : "true");
  paneel.hidden = open;
});

document.addEventListener("keydown", function (e) {
  if (e.key !== "Enter" && e.key !== " ") return;
  var chev = e.target.closest("[data-bab-detail]");
  if (!chev) return;
  e.preventDefault();
  chev.click();
});

/* ==========================================================================
   Keuzeblok in de koopkolom: kiezen, niet kopen
   Een klik op een keuzekaart selecteert hem en klapt de tabel open met een klein
   fotootje per artikel. Pas de knop "Add to cart" legt de gekozen combinatie in de
   wagen. Zo ziet de klant eerst wát hij erbij krijgt.
   ========================================================================== */
(function () {
  function kies(optie) {
    var groep = optie.closest(".bab-bb-keuze");
    if (!groep) return;
    groep.querySelectorAll("[data-bab-kies]").forEach(function (o) {
      var aan = o === optie;
      o.classList.toggle("is-active", aan);
      if (o.hasAttribute("aria-expanded")) o.setAttribute("aria-expanded", aan ? "true" : "false");
      var wrap = o.closest(".bab-bb-duo");
      var paneel = wrap && wrap.querySelector("[data-bab-detail-panel]");
      if (paneel) paneel.hidden = !aan;
    });
  }

  window.babKiesOptie = kies;

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-bab-detail]")) return; /* chevron doet zijn eigen ding */
    var optie = e.target.closest(".bab-bb-keuze [data-bab-kies]");
    if (!optie) return;
    e.preventDefault();
    kies(optie);
  });

  /* De knop van het thema post het formulier. Staat er een bundel gekozen, dan
     onderscheppen we dat in de capture-fase — vóór Horizon's eigen handler — en
     leggen we beide artikelen erin. */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    var actief = document.querySelector(".bab-bb--duo .bab-bb-optie.is-active[data-bab-add]");
    if (!actief) return; /* "Just this one" of geen keuzeblok: gewoon doorlaten */

    e.preventDefault();
    e.stopPropagation();

    var items;
    try { items = JSON.parse(actief.getAttribute("data-bab-add")); } catch (err) { return; }
    var gekozen = form.querySelector('input[name="id"]');
    if (gekozen && gekozen.value && items[0]) items[0].id = Number(gekozen.value);

    var knop = form.querySelector("button[name=add]");
    if (knop) knop.setAttribute("aria-busy", "true");

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items, sections: "cart-drawer-section,cart-icon-bubble" }),
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (data) { toonWagen(data.sections || {}); })
      .catch(function (err) { console.error("bab-bundel:", err); window.location.href = "/cart"; })
      .then(function () { if (knop) knop.removeAttribute("aria-busy"); });
  }, true);
})();


/* ── Winkelwagen-upsell ───────────────────────────────────────────────────
   Twee dingen boven de afrekenknop: hoeveel er nog bij moet voor gratis
   verzending, en twee kleine artikelen om dat gat mee te vullen. De balk is de
   eigenlijke motor — mensen leggen er iets bij om de verzending niet te betalen.
   Bewust GEEN dure upsell hier: in de winkelwagen is de beslissing al genomen. */
(function () {
  function lees(id, val) {
    var el = document.getElementById(id);
    if (!el) return val;
    try { return JSON.parse(el.textContent); } catch (e) { return val; }
  }
  var PRODUCTEN = lees('bab-cart-upsells', []);
  var CFG = lees('bab-cart-config', { drempel: 7000, valuta: '€' });

  function geld(cent) {
    return CFG.valuta + (cent / 100).toFixed(2).replace('.', ',');
  }

  function maakBlok(cart) {
    var el = document.createElement('div');
    el.className = 'bab-cu';

    var tekort = CFG.drempel - cart.total_price;
    var pct = Math.max(0, Math.min(100, (cart.total_price / CFG.drempel) * 100));
    var balk =
      '<div class="bab-cu-ship">' +
        '<p class="bab-cu-ship-tekst">' +
          (tekort > 0
            ? 'Nog <b>' + geld(tekort) + '</b> en je verzending is gratis'
            : '<b>Gelukt — je verzending is gratis</b>') +
        '</p>' +
        '<span class="bab-cu-balk"><i style="width:' + pct.toFixed(1) + '%"></i></span>' +
      '</div>';

    var inCart = (cart.items || []).map(function (i) { return i.product_id; });
    var kandidaten = PRODUCTEN.filter(function (p) { return inCart.indexOf(p.pid) === -1; });
    /* Eerst wat het gat het netst dicht: het goedkoopste artikel dat eroverheen tilt. */
    if (tekort > 0) {
      kandidaten.sort(function (a, b) {
        var ga = a.prijs >= tekort ? 0 : 1, gb = b.prijs >= tekort ? 0 : 1;
        return ga - gb || a.prijs - b.prijs;
      });
    }
    var toon = kandidaten.slice(0, 2);
    if (!toon.length) { el.innerHTML = balk; return el; }

    var kaarten = toon.map(function (p) {
      return '<li class="bab-cu-kaart">' +
        '<img class="bab-cu-foto" src="' + p.foto + '" alt="" width="52" height="52" loading="lazy">' +
        '<span class="bab-cu-tekst"><a class="bab-cu-naam" href="' + p.url + '">' + p.titel + '</a>' +
        '<span class="bab-cu-prijs">' + geld(p.prijs) + '</span></span>' +
        '<button type="button" class="bab-cu-knop" data-bab-cu-add="' + p.id + '">Toevoegen</button>' +
      '</li>';
    }).join('');

    el.innerHTML = balk +
      '<p class="bab-cu-kop">Vaak samen gekocht</p>' +
      '<ul class="bab-cu-lijst">' + kaarten + '</ul>';
    return el;
  }

  /* Sleutel van de winkelwagen: alleen hertekenen als er iets veranderd is.
     Zonder deze controle verwijderde en herplaatste dit blok zichzelf, wat de
     MutationObserver hieronder opnieuw liet vuren — een eindeloze lus die
     onafgebroken /cart.js bleef ophalen. */
  var laatsteSleutel = null;
  var observer = null;

  function sleutelVan(cart) {
    return cart.item_count + '|' + cart.total_price + '|' +
      (cart.items || []).map(function (i) { return i.id + 'x' + i.quantity; }).join(',');
  }

  function plaats(cart, forceer) {
    var sleutel = sleutelVan(cart);
    var bestaat = document.querySelector('.bab-cu');
    if (!forceer && bestaat && sleutel === laatsteSleutel) return;
    laatsteSleutel = sleutel;

    /* Observer even uitzetten: onze eigen DOM-schrijfacties mogen hem niet triggeren. */
    if (observer) observer.disconnect();
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var houder = ctas.parentElement;
      if (!houder) return;
      var oud = houder.querySelector('.bab-cu');
      if (oud) oud.remove();
      houder.insertBefore(maakBlok(cart), ctas);
    });
    if (observer) kijkMee();
  }

  var bezig = false, laatsteFetch = 0;
  function ververs(forceer) {
    var nu = Date.now();
    /* Nooit vaker dan eens per seconde, wat er ook gebeurt in de DOM. */
    if (bezig || (!forceer && nu - laatsteFetch < 1000)) return;
    bezig = true; laatsteFetch = nu;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (cart && cart.items && cart.items.length) plaats(cart, forceer); })
      .catch(function () {})
      .then(function () { bezig = false; });
  }

  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('[data-bab-cu-add]');
    if (!knop) return;
    e.preventDefault();
    knop.disabled = true;
    knop.textContent = 'Bezig…';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(knop.getAttribute('data-bab-cu-add')), quantity: 1 }],
        sections: 'cart-drawer-section,cart-icon-bubble'
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (typeof babVervangWagen === 'function') babVervangWagen(d.sections || {});
        setTimeout(function () { ververs(true); }, 120);
      })
      .catch(function () { knop.disabled = false; knop.textContent = 'Toevoegen'; });
  });

  var wacht;
  function kijkMee() {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    ververs(true);
    /* De drawer wordt na elke cart-wijziging opnieuw ingevoegd, dus meekijken —
       maar alleen reageren als de winkelwagen zelf veranderd is. */
    observer = new MutationObserver(function (muts) {
      var raak = muts.some(function (m) {
        return m.target && m.target.closest &&
               (m.target.closest('cart-drawer-component, .cart-drawer, .cart__ctas, cart-items-component') ||
                m.target.matches && m.target.matches('cart-drawer-component, .cart-drawer'));
      });
      if (!raak) return;
      clearTimeout(wacht);
      wacht = setTimeout(function () { ververs(); }, 250);
    });
    kijkMee();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


/* ── Sticky koopknop op telefoon ──────────────────────────────────────────
   De productpagina is lang: koopblok, video, raster, bewijs, FAQ. Zodra de
   echte knop uit beeld is, is er geen manier meer om te kopen zonder terug te
   scrollen. Deze balk verschijnt dan onderaan en klikt de ECHTE knop aan, zodat
   variantkeuze en bundelkeuze gewoon meegaan. Alleen onder 900px. */
(function () {
  function echteKnop() {
    return document.querySelector('[data-blp-atc]') ||
           document.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
           document.querySelector('form[action*="/cart/add"] [name="add"]');
  }

  function prijsNu() {
    var el = document.querySelector('[data-blp-option].is-active .blp-bundle-price') ||
             document.querySelector('.blp-bundle-price') ||
             document.querySelector('.product-information__container product-price .price') ||
             document.querySelector('product-price');
    return el ? el.textContent.trim().split('\n')[0] : '';
  }

  function start() {
    if (window.innerWidth >= 900) return;
    var knop = echteKnop();
    if (!knop) return;

    var bar = document.createElement('div');
    bar.className = 'bab-sticky';
    bar.innerHTML =
      '<span class="bab-sticky-prijs"></span>' +
      '<button type="button" class="bab-sticky-knop">In winkelwagen</button>';
    document.body.appendChild(bar);

    var prijsEl = bar.querySelector('.bab-sticky-prijs');
    bar.querySelector('.bab-sticky-knop').addEventListener('click', function () {
      var k = echteKnop();
      if (k) k.click();
    });

    function ververs() { prijsEl.textContent = prijsNu(); }
    ververs();

    /* Tonen zodra de echte knop boven het scherm uit is gescrold. */
    new IntersectionObserver(function (e) {
      var uit = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-open', uit);
      if (uit) ververs();
    }, { threshold: 0 }).observe(knop);

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-blp-option],[data-bab-kies],.blp-variant-pill'))
        setTimeout(ververs, 80);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
